$(document).ready(function () {
    $('select[name="NextBoxDespatchDate"]').each(function () {
        $(this).val($(this).data('selected'));
    });

    $('.changeCardModal').on('show.bs.modal', function () {
        var cardElementDiv = $(this).find('div[id|="card-element"]')[0];
        // Unmount the card Element before we try to attach it
        card.unmount();
        // Add an instance of the card Element into the 'card-element' <div>
        card.mount(cardElementDiv);
    });

    $('.changeCardRadioArea').each(function () {
        if ($(this).children().length > 5) {
            $(this).children(':nth-child(n+5)').hide();
            var showMore = $('<a href="#" class="showMore align-self-start">Show more</a>');
            $(this).append(showMore);
        }
    });

    $('.changeCardRadioArea').on('change', 'input[type="radio"]', function () {
        if ($(this).prop('checked')) {
            $(this).parents('.changeCardRadioArea').children('.border-primary').removeClass('border-primary').find('.changeCardRemoveButton').prop('disabled', false);
            $(this).parents('.changeCardDetails, .addCardDetails').addClass('border-primary').find('.changeCardRemoveButton').prop('disabled', true);

            if ($(this).val() === 'new') {
                $(this).parents('.addCardDetails').find('.changeCardEditArea').removeClass('d-none').hide().slideDown();
            } else {
                $('.addCardDetails .changeCardEditArea').slideUp(function () {
                    $('.addCardDetails .changeCardEditArea').addClass('d-none').show();
                });
            }
        }
    });

    $('.changeCardRadioArea').on('click', '.showMore', function () {
        $(this).hide().siblings().show();
    });

    $('.changeCardRadioArea').on('click', '.changeCardEditButton', function () {
        var changeCardDetails = $(this).parents('.changeCardDetails');
        var changeCardEditArea = changeCardDetails.children('.changeCardEditArea');
        if (changeCardEditArea.hasClass('d-none')) {
            changeCardEditArea.removeClass('d-none').hide().slideDown();
            changeCardDetails.find('input:regex(name,editedMethods\\[\\d+\\])').val(changeCardDetails.find('input:regex(name,methods\\[\\d+\\]\\[Id\\])').val());
        } else {
            changeCardEditArea.slideUp(function () {
                $(this).addClass('d-none').show();
            });
        }
    });

    $('.changeCardRadioArea').on('click', '.changeCardRemoveButton', function () {
        var changeCardDetails = $(this).parents('.changeCardDetails');
        var changeCardEditArea = changeCardDetails.children('.changeCardEditArea');
        if (!changeCardEditArea.hasClass('d-none')) {
            changeCardEditArea.slideUp(function () {
                $(this).addClass('d-none').show();
            });
        }
        changeCardDetails.fadeTo(400, 0.2);
        changeCardDetails.find('input[name="selectedMethodId"], .changeCardEditButton, .changeCardRemoveButton').prop('disabled', true);
        changeCardDetails.find('input:regex(name,removedMethods\\[\\d+\\])').val(changeCardDetails.find('input:regex(name,methods\\[\\d+\\]\\[Id\\])').val());
    });

    $('.changeCardForm').on('submit', function (e) {
        e.preventDefault();

        var form = $(this);

        if (form.valid()) {
            var backdrop = $('<div class="modal-backdrop show"></div>').css('z-index', 1050).appendTo('body');
            reflow(backdrop[0]);
            backdrop.addClass('show');

            var loading = $('<div class="fullscreen-loading-indicator text-white"></div>').css('z-index', 1060).appendTo('body');
            loading.append($('<i class="fas fa-circle-notch fa-spin fa-3x fa-fw"></i>'));
            loading.append($('<span class="sr-only">Loading...</span>'));

            // serializeObject() is a very clever function to JSON-ify form contents intelligently
            // https://github.com/macek/jquery-serialize-object
            var formData = form.serializeObject();
            var url = form.attr('action');

            if (formData.selectedMethodId === 'new') {
                var cardElement = form.find('div[id|="card-element"]');
                var cardErrors = form.find('span[id|="card-errors"]');

                stripe.createPaymentMethod('card', card, {
                    billing_details: {
                        name: $.trim(form.find('input[name="NewCardAddress.Name"]').val()),
                        address: {
                            line1: $.trim(form.find('input[name="NewCardAddress.Line1"]').val()),
                            line2: $.trim(form.find('input[name="NewCardAddress.Line2"]').val()),
                            city: $.trim(form.find('input[name="NewCardAddress.TownCity"]').val()),
                            postal_code: $.trim(form.find('input[name="NewCardAddress.Postcode"]').val()),
                            country: $.trim(form.find('select[name="NewCardAddress.CountryCode"]').val())
                        }
                    }
                }).then(function (result) {
                    if (result.error) {
                        backdrop.remove();
                        loading.remove();

                        cardElement.addClass('StripeElement--invalid');
                        cardErrors.text(result.error.message);
                    } else {
                        formData.selectedMethodId = result.paymentMethod.id;

                        $.post(url, formData, function (data) { window.location.reload(true); }, 'json');
                    }
                });
            } else {
                $.post(url, formData, function (data) { window.location.reload(true); }, 'json');
            }
        }
    });

    $('.cancelSubscriptionForm').on('submit', function (e) {
        e.preventDefault();

        var form = $(this);

        var backdrop = $('<div class="modal-backdrop show"></div>').css('z-index', 1050).appendTo('body');
        reflow(backdrop[0]);
        backdrop.addClass('show');

        var loading = $('<div class="fullscreen-loading-indicator text-white"></div>').css('z-index', 1060).appendTo('body');
        loading.append($('<i class="fas fa-circle-notch fa-spin fa-3x fa-fw"></i>'));
        loading.append($('<span class="sr-only">Loading...</span>'));

        var formData = form.serializeObject();
        var url = form.attr('action');

        $.post(url, formData, function (data) { window.location.reload(true); }, 'json');
    });
});

function UpdateShopProductAddress(data) {
    if (data.responseJSON.success) {
        $('#changeAddressModal' + data.responseJSON.guid).modal('hide');

        var shopProductArea = $('.shop-product-area[data-guid="' + data.responseJSON.guid + '"]');
        shopProductArea.find('.addressPreview').text(data.responseJSON.addressSingleLine).attr('title', data.responseJSON.address);
    }
}

function UpdateShopProductGiftMessage(data) {
    if (data.responseJSON.success) {
        $('#changeGiftMessageModal' + data.responseJSON.guid).modal('hide');
    }
}

function UpdateShopProductDespatchDate(data) {
    if (data.responseJSON.success) {
        $('#changeDateModal' + data.responseJSON.guid).modal('hide');

        var shopProductArea = $('.shop-product-area[data-guid="' + data.responseJSON.guid + '"]');
        shopProductArea.find('.despatch-date-area').html('').append(data.responseJSON.despatchDate);
    }
}

function UpdateSubscriptionAddress(data) {
    if (data.responseJSON.success) {
        $('#changeAddressModal' + data.responseJSON.guid).modal('hide');

        var subscriptionArea = $('.subscription-area[data-guid="' + data.responseJSON.guid + '"]');
        subscriptionArea.find('.delivery-address-area').html('').append(data.responseJSON.address);
    }
}

function UpdateSubscriptionGiftMessage(data) {
    if (data.responseJSON.success) {
        $('#changeGiftMessageModal' + data.responseJSON.guid).modal('hide');
    }
}

function UpdateSubscriptionDespatchDate(data) {
    if (data.responseJSON.success) {
        $('#changeDateModal' + data.responseJSON.guid).modal('hide');

        var subscriptionArea = $('.subscription-area[data-guid="' + data.responseJSON.guid + '"]');
        subscriptionArea.find('.despatch-date-area').html('').append(data.responseJSON.despatchDate);
        subscriptionArea.find('.despatch-date-change-deadline, .delivery-address-change-deadline').html('').append(data.responseJSON.deadlineDate);
    }
}

function reflow(element) {
    return element.offsetHeight;
}